// Vendor imports
const classNames = require('classnames')
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { FeedItemRecord } = require('client-v2/common/containers/feed/records')
// Sibling imports
const FeaturedCarousel = require('./featured-carousel')
const FeaturedCollectionSlide = require('./featured-collection-slide')

const bem = BemEntity('FeaturedCollectionsCarousel')

class FeaturedCollectionsCarousel extends React.PureComponent {
  constructor(props) {
    super(props)
    // Ensure function references do not change between render calls
    this.renderSlide = this.renderSlide.bind(this)
  }

  renderSlide(item) {
    return (
      tag(FeaturedCollectionSlide, {
        ...this.props,
        key: `FeaturedCollectionsCarouselSlide:${item.id}`,
        className: bem.element('slide'),
        collection: item.collection,
        isSelf: item.collection['user_id'] === this.props.selfUserId,
        pageContext: item.pageContext
      })
    )
  }

  render() {
    if (this.props.items.length === 0) {
      return null
    }
    return (
      tag(FeaturedCarousel, {
        className: classNames(
          this.props.className,
          bem.block()
        ),
        items: this.props.items,
        renderSlide: this.renderSlide
      })
    )
  }
}

FeaturedCollectionsCarousel.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape(FeedItemRecord.propTypes)
  ).isRequired,
  selfUserId: PropTypes.number
}

module.exports = FeaturedCollectionsCarousel
